// extracted by mini-css-extract-plugin
export var blue = "_2i-h";
export var brand = "_2i-d";
export var darkGrey = "_2i-g";
export var disabled = "_2i-6";
export var disabledSubtle = "_2i-7";
export var error = "_2i-8";
export var green = "_2i-i";
export var grey = "_2i-f";
export var icon = "_2i-0";
export var inherit = "_2i-c";
export var lightGrey = "_2i-e";
export var orange = "_2i-k";
export var pink = "_2i-m";
export var primary = "_2i-1";
export var purple = "_2i-n";
export var quaternary = "_2i-4";
export var quinary = "_2i-5";
export var red = "_2i-l";
export var secondary = "_2i-2";
export var success = "_2i-b";
export var tertiary = "_2i-3";
export var warning = "_2i-9";
export var warningSecondary = "_2i-a";
export var white = "_2i-o";
export var yellow = "_2i-j";